import { configureStore } from '@reduxjs/toolkit';

import filterReducer from './reducers/filter';
import tipsDataReducer from './reducers/tipsData';
import dialogReducer from './reducers/dialog';
import editTipsSlice from './reducers/editTips';
import authentication from './reducers/auth-slice';
import countries from './reducers/country-slice';
import regions from './reducers/region-slice';
import chapters from './reducers/chapter-slice';
import inputDialogBox from './reducers/inputdialog-slice';
import profileSlice from './reducers/profile-slice';
import headerReducer from './reducers/header';


const store = configureStore({
    reducer:  {
        auth: authentication,
        filter: filterReducer,
        tipsData: tipsDataReducer,
        dialog: dialogReducer,
        editTips: editTipsSlice,
        countries: countries,
        regions: regions,
        chapters: chapters,
        inputDialogBox: inputDialogBox,
        profileDetails: profileSlice,
        header: headerReducer
    }
});

export default store;